import * as React from "react";
import { useEffect } from "react";
import { StyleSheet, View } from "react-native";
import { useFormikContext } from "formik";
import * as Yup from "yup";

import { FormikTextInputField, Panel, Typography, VStack } from "@smartrent/ui";

import type { NetsuiteFormValues as FormValues } from "../types";

export const NetsuiteContactInfoForm: React.FC = () => {
  const { values: formValues, setFieldValue } = useFormikContext<FormValues>();
  const netsuiteData = formValues.netsuiteData;

  // Auto-populate fields
  useEffect(() => {
    if (netsuiteData) {
      setFieldValue(
        "contact_info_management_company",
        netsuiteData.customerName
      );
      setFieldValue("contact_info_property", netsuiteData.propertyName);
      setFieldValue("contact_info_po_number", "Not Applicable");
    }
  }, [netsuiteData, setFieldValue]);

  return (
    <VStack spacing={24}>
      <Panel>
        <View style={styles.sectionHeader}>
          <Typography type="title3">Management Info</Typography>
        </View>

        <VStack spacing={16}>
          <FormikTextInputField
            name="contact_info_management_company"
            label="Management Company"
            disabled
            textInputProps={{
              placeholder: "Auto-filled from property",
            }}
          />

          <FormikTextInputField
            name="contact_info_property"
            label="Property"
            disabled
            textInputProps={{
              placeholder: "Auto-filled from property",
            }}
          />

          <FormikTextInputField
            name="contact_info_po_number"
            label="PO Number"
            disabled
            textInputProps={{
              placeholder: "Auto-filled for warranty orders",
            }}
          />
        </VStack>
      </Panel>

      <Panel>
        <View style={styles.sectionHeader}>
          <Typography type="title3">Warranty Requested By</Typography>
        </View>

        <VStack spacing={16}>
          <FormikTextInputField
            name="contact_info_phone"
            label="Phone"
            textInputProps={{
              placeholder: "(555) 123-4567",
            }}
          />

          <FormikTextInputField
            name="contact_info_name"
            label="Name"
            textInputProps={{
              placeholder: "Enter caller's name",
            }}
          />

          <FormikTextInputField
            name="contact_info_email"
            label="Email"
            textInputProps={{
              placeholder: "Enter caller's email",
            }}
          />
        </VStack>
      </Panel>
    </VStack>
  );
};

// Validation schema for this step
export const contactInfoValidationSchema = Yup.object().shape({
  contact_info_phone: Yup.string().required("Phone is required"),
  contact_info_management_company: Yup.string().required(
    "Management company is required"
  ),
  contact_info_property: Yup.string().required("Property is required"),
  contact_info_po_number: Yup.string().test(
    "po-required",
    "PO number is required for this property",
    function (value) {
      const netsuiteData = this.parent?.netsuiteData;
      if (netsuiteData?.poRequired) {
        return !!value && value.trim().length > 0;
      }
      return true;
    }
  ),
  contact_info_name: Yup.string().required("Name is required"),
  contact_info_email: Yup.string()
    .email("Must be a valid email")
    .required("Email is required"),
});

const styles = StyleSheet.create({
  sectionHeader: {
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
  },
});
